var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.name))])]),_c('div',[_c('i',[_vm._v(_vm._s(_vm.email))])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.about)}})])}
var staticRenderFns = []

export { render, staticRenderFns }